module.exports = __webpack_public_path__ + "img/connector_bg_1.a11c8299.png";